// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__8_TsW","title":"Images45_title__TMaW6","images":"Images45_images__3MO3A"};